import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Portugu\xEAs (Brasil)",
  code: "pt-BR",
  messages: {
    alert: {
      close: "Fechar"
    },
    authForm: {
      hidePassword: "Ocultar senha",
      showPassword: "Mostrar senha",
      submit: "Continuar"
    },
    banner: {
      close: "Fechar"
    },
    calendar: {
      nextMonth: "Pr\xF3ximo m\xEAs",
      nextYear: "Pr\xF3ximo ano",
      prevMonth: "M\xEAs anterior",
      prevYear: "Ano anterior"
    },
    carousel: {
      dots: "Escolher slide para exibir",
      goto: "Ir para a slide {slide}",
      next: "Pr\xF3ximo",
      prev: "Anterior"
    },
    chatPrompt: {
      placeholder: "Escreva sua mensagem aqui..."
    },
    chatPromptSubmit: {
      label: "Enviar"
    },
    colorMode: {
      dark: "Escuro",
      light: "Claro",
      switchToDark: "Mudar para modo escuro",
      switchToLight: "Mudar para modo claro",
      system: "Sistema"
    },
    commandPalette: {
      back: "Voltar",
      close: "Fechar",
      noData: "Nenhum dado",
      noMatch: "Nenhum dado correspondente",
      placeholder: "Digite um comando ou pesquise..."
    },
    contentSearch: {
      links: "Links",
      theme: "Tema"
    },
    contentSearchButton: {
      label: "Pesquisar..."
    },
    contentToc: {
      title: "Nesta p\xE1gina"
    },
    dashboardSearch: {
      theme: "Tema"
    },
    dashboardSearchButton: {
      label: "Pesquisar..."
    },
    dashboardSidebarCollapse: {
      collapse: "Recolher barra lateral",
      expand: "Expandir barra lateral"
    },
    dashboardSidebarToggle: {
      close: "Fechar barra lateral",
      open: "Abrir barra lateral"
    },
    error: {
      clear: "Voltar para a p\xE1gina inicial"
    },
    fileUpload: {
      removeFile: "Remover {filename}"
    },
    header: {
      close: "Fechar menu",
      open: "Abrir menu"
    },
    inputMenu: {
      create: 'Criar "{label}"',
      noData: "Nenhum dado",
      noMatch: "Nenhum dado correspondente"
    },
    inputNumber: {
      decrement: "Decrementar",
      increment: "Incrementar"
    },
    modal: {
      close: "Fechar"
    },
    pricingTable: {
      caption: "Compara\xE7\xE3o de planos de pre\xE7os"
    },
    prose: {
      codeCollapse: {
        closeText: "Recolher",
        name: "c\xF3digo",
        openText: "Expandir"
      },
      collapsible: {
        closeText: "Ocultar",
        name: "propriedades",
        openText: "Mostrar"
      },
      pre: {
        copy: "Copiar c\xF3digo para a \xE1rea de transfer\xEAncia"
      }
    },
    selectMenu: {
      create: 'Criar "{label}"',
      noData: "Nenhum dado",
      noMatch: "Nenhum dado correspondente",
      search: "Pesquisar..."
    },
    slideover: {
      close: "Fechar"
    },
    table: {
      noData: "Nenhum dado"
    },
    toast: {
      close: "Fechar"
    }
  }
});
